import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StaffService } from 'src/app/service/staff.service';
import { Staff } from 'src/app/entity/Staff';
 
 
 

@Component({
  selector: 'app-dialog-user-lists',
  templateUrl: './dialog-user-lists.component.html',
  styleUrls: ['./dialog-user-lists.component.css']
})
export class DialogUserListsComponent implements OnInit {

  selectedStaff: Staff;
  staffs: Staff[]
   @Input() visibleUsers:boolean
   @Output()
   select: EventEmitter<Staff> = new EventEmitter<Staff>();
  constructor(private staffService: StaffService) { }

  ngOnInit() {
    
    this.findAllStaffs()
  }

  findAllStaffs() {
    this.staffService.getAllStaffs().subscribe(result => {
      this.staffs = result
    })
  }


  selectStaff($event ){
 
   
   this.select.emit($event.option)

   
 }
 

hide(){
  this.select.emit(null)
}
 
 
  
}
